module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-fuel/individual-fuel.component.css
// module id = ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-fuel/individual-fuel.component.css
// module chunks = main